import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem('admin_token');
};

// Set auth token in localStorage
const setAuthToken = (token) => {
  localStorage.setItem('admin_token', token);
};

// Remove auth token
const removeAuthToken = () => {
  localStorage.removeItem('admin_token');
};

// Admin Auth API
export const adminAuthAPI = {
  // Login
  login: async (email, password) => {
    try {
      const response = await axios.post(`${API}/admin/login`, { email, password });
      if (response.data.access_token) {
        setAuthToken(response.data.access_token);
      }
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  // Verify token
  verify: async () => {
    try {
      const token = getAuthToken();
      if (!token) return false;
      
      const response = await axios.get(`${API}/admin/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      removeAuthToken();
      return false;
    }
  },

  // Logout
  logout: () => {
    removeAuthToken();
  },

  // Check if logged in
  isAuthenticated: () => {
    return !!getAuthToken();
  }
};

// Admin Analytics API
export const adminAnalyticsAPI = {
  // Get analytics
  getAnalytics: async () => {
    try {
      const token = getAuthToken();
      const response = await axios.get(`${API}/admin/analytics`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching analytics:', error);
      throw error;
    }
  }
};

// Admin Blog API (with auth)
export const adminBlogAPI = {
  createPost: async (postData) => {
    try {
      const token = getAuthToken();
      const response = await axios.post(`${API}/blog`, postData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error creating post:', error);
      throw error;
    }
  },

  updatePost: async (postId, postData) => {
    try {
      const token = getAuthToken();
      const response = await axios.put(`${API}/blog/${postId}`, postData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating post:', error);
      throw error;
    }
  },

  deletePost: async (postId) => {
    try {
      const token = getAuthToken();
      const response = await axios.delete(`${API}/blog/${postId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting post:', error);
      throw error;
    }
  }
};

export { getAuthToken, setAuthToken, removeAuthToken };
